<template>
  <div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Medidas</th>
          <th scope="col">Resultados {{ anio }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="td">i. Diagnóstico institucional de género.</td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.diagnosticoInstitucional"
            ></b-form-textarea>
          </td>
        </tr>

        <tr>
          <td class="td">
            iii. Política institucional de gestión de personas con perspectiva
            de género.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.politicaInstitucional"
            ></b-form-textarea>
          </td>
        </tr>

        <tr>
          <td class="td">
            iv. Protocolos y/o procedimientos en caso de maltrato, acoso sexual
            y/o laboral con perspectiva de género.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.protocolos"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td class="td">
            v. Capacitación a funcionarias/os del servicio en materia de género
            nivel básico.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.capacitacionBasico"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td class="td">
            vi. Capacitación a funcionarias/os del servicio en materia de género
            nivel avanzado (aplicado al quehacer del servicio).
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.capacitacionAvanzado"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td class="td">
            vii. Comunicaciones y difusión interna y externa con perspectiva de
            género.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.comunicaciones"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td class="td">
            viii. Políticas y programas públicos elaborados por el servicio:
            perspectiva de género en el diseño, implementación, seguimiento y/o
            evaluación de uno o más programas públicos.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.politicasElaboradas"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td class="td">
            ix. Legislación/normativa con perspectiva de género.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.legislacion"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td class="td">
            x. Estudios, datos y estadísticas con información desagregada por
            sexo.
          </td>
          <td>
            <b-form-textarea
              :disabled="readOnly"
              class="text-sm"
              v-model="cosoTablaUno.estudios"
            ></b-form-textarea>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      anio: process.env.VUE_APP_ANIO,
    };
  },
  props: ["cosoTablaUno", "readOnly"],
};
</script>

<style scoped>
.text-sm {
  font-size: 0.8rem;

}
th {
  text-align: left !important;
  font-size: 14px !important ;
}

td {
  text-align: center;
}

.table {
  border: 1px solid #ccc;
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  text-align: left;
}

.div {
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 30%;
  padding: 5px;
  text-align: left !important;
  font-size: 13px;
}

td {
  text-align: left;
  font-size: 16px;
}
</style>
